import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { useCookies } from "react-cookie"

const HeaderBanner = () => {
  const [cookies] = useCookies([]);
  const [isLoggedIn, setIsLoggedIn] = useState(null)

  useEffect(() => {
    setIsLoggedIn(!!cookies['member_id'])
  }, [])

  return (
    <>
      {(isLoggedIn === null || !isLoggedIn) && (
        <div className="point-banner-pc header-top">
          <a href="https://laxus.co/app/pc/login/register">会員登録（無料）でまずはバッグをご覧ください！<span>今すぐお試し</span></a>
        </div>
      )}
      {(isLoggedIn === null || !isLoggedIn) && (
        <div className="point-banner-sp header-top">
          <a href="https://app.adjust.com/2zhh5ty">アプリで簡単レンタル！<br />会員登録（無料）でまずはバッグをご覧ください！</a>
        </div>
      )}
    </>
  )
}

HeaderBanner.propTypes = {
  siteTitle: PropTypes.string,
}

HeaderBanner.defaultProps = {
  siteTitle: ``,
}

export default HeaderBanner
